import { retrieveUserIgAccounts } from "services/SauceService";

export async function instagramPageLoader() {
  const pages = await retrieveUserIgAccounts();

  return { pages };
}
